import script from "./SummaryProblem.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryProblem.vue?vue&type=script&setup=true&lang=js"

import "./SummaryProblem.vue?vue&type=style&index=0&id=30a1f08e&lang=scss"

const __exports__ = script;

export default __exports__